import { feature } from "topojson";
import { useState, useEffect} from "react";
// import californiaTopo from "./california.topo.json";
// import wgsBoundingBox from "./wgsBoundingBox.json";
const californiaTopoFile = `${process.env.PUBLIC_URL}/maps/california.topo.json`;
const wgsBoundingBoxFile = `${process.env.PUBLIC_URL}/maps/wgsBoundingBox.json`;

export default function useCaliforniaOutline() {
  const [california, setCalifornia] = useState(null);
  const [worldWithoutCalifornia, setWorldWithoutCalifornia] = useState(null);
  useEffect(() => {
    const fetchFiles = async () => {
      return Promise.all([
        fetch(californiaTopoFile).then(response => response.json()),
        fetch(wgsBoundingBoxFile).then(response => response.json()),
      ])
    }
    fetchFiles().then(files => {
      const [californiaTopo, wgsBoundingBox] = files;

      const features = feature(californiaTopo, californiaTopo.objects.california);

      // simplify california...
      features.features[0].geometry.coordinates = features.features[0].geometry.coordinates.slice(-1)

      if (wgsBoundingBox.features[0].geometry.coordinates.length === 1) {
        wgsBoundingBox.features[0].geometry.coordinates.push(features.features[0].geometry.coordinates[0][0])
      }
      setWorldWithoutCalifornia(wgsBoundingBox)
      window.wgsBoundingBox = wgsBoundingBox
      setCalifornia(features);
    })
  }, []);

  return { california, worldWithoutCalifornia };
}
